import { render } from "./ClientsTableList.vue?vue&type=template&id=0a0aa94c"
import script from "./ClientsTableList.vue?vue&type=script&lang=js"
export * from "./ClientsTableList.vue?vue&type=script&lang=js"

import "./ClientsTableList.vue?vue&type=style&index=0&id=0a0aa94c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__